import { React, useState } from 'react';

import Box from '@mui/material/Box';
import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';

import InserirFalhasBulk from '../../components/inserirFalhaBulk';
import InserirFalhaIndividual from '../../components/inserirFalhaIndividual';
import PageHeader from '../../components/pageHeader';
import { ModePanel, SegmentedControl } from '../../components/ui';
import '../css/failureEntry.css';

const InserirFalhas = () => {
    const [tipo, setTipo] = useState('individual');
    const isBulk = tipo === 'bulk';

    return (
        <Box className='mainBox ui-workflow-page'>
            <PageHeader>{isBulk ? 'Inserir Falhas CSV' : 'Inserir Falhas'}</PageHeader>

            <ModePanel icon={isBulk ? TableChartRoundedIcon : BugReportRoundedIcon} title={isBulk ? 'Envio por CSV' : 'Inserção individual'}>
                <SegmentedControl
                    ariaLabel='Alternar entre inserção individual e CSV'
                    value={tipo}
                    onChange={setTipo}
                    options={[
                        { value: 'individual', label: 'Individual', icon: BugReportRoundedIcon },
                        { value: 'bulk', label: 'CSV', icon: TableChartRoundedIcon }
                    ]}
                />
            </ModePanel>

            {isBulk ? <InserirFalhasBulk /> : <InserirFalhaIndividual /> }
        </Box>
    );
};

export default InserirFalhas;
